// Skeleton.js
import React from "react";
import "./Skeleton.css";

const Skeleton = ({ showLeft = true, showRight = true }) => {
  return (
    <div className="skeleton-layout">
      {/* Left Panel */}
      {showLeft && (
        <div className="skeleton-left">
          <div className="skeleton-audio"></div>

          <div className="skeleton-tabs">
            <div className="skeleton-tab"></div>
            <div className="skeleton-tab"></div>
            <div className="skeleton-tab"></div>
          </div>

          <div className="skeleton-table">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="skeleton-row"></div>
            ))}
          </div>
        </div>
      )}

      {/* Right Panel */}
      {showRight && (
        <div className="skeleton-right">
          <div className="skeleton-tabs">
            <div className="skeleton-tab"></div>
            <div className="skeleton-tab"></div>
            <div className="skeleton-tab"></div>
          </div>

          <div className="skeleton-box"></div>
          <div className="skeleton-box"></div>
          <div className="skeleton-box"></div>
        </div>
      )}
    </div>
  );
};

export default Skeleton;
